import React from 'react'
import { TaskActivityBase } from './TaskActivityBase'
import { TaskActivity } from '@core/entities/task/TaskActivity'
import { Task } from '@core/entities/task/Task'
import { TaskStepAction } from '../TaskStepAction'
import { TaskRequestApproveChangesActions } from '../TaskRequestApproveChangesActions'

type TaskActivityCurrentStepProps = {
  activity: TaskActivity
  task: Task
  bgColor?: string
  isModal?: boolean
}

export const TaskActivityCurrentStep: React.FC<
  TaskActivityCurrentStepProps
> = ({ activity, task, bgColor, isModal }) => {
  return (
    <TaskActivityBase
      name={activity.step.name || ''}
      user={task.assignee}
      type={activity.step.type}
      active
      color={activity.getStepTypeColor()}
      bgColor={bgColor}
      isModal={isModal}
    >
      <TaskStepAction task={task} />
      {(task.isAwaitingApproval() || task.hasRequestedChanges()) && (
        <TaskRequestApproveChangesActions task={task} />
      )}
    </TaskActivityBase>
  )
}
